<template>
  <collapsible-widget
    :collapsed="collapsed"
    :uuid="uuid"
    :title="title_component"
    badge="badge_360"
    colorBadge="info"
  >
    <video
      id="videojs-vr-player"
      class="video-js vjs-default-skin"
      style="margin-left: auto;margin-right: auto;"
      preload="auto"
      crossorigin="anonymous"
      data-setup="{}"
      controls
    >
      <source
        src="https://player.vimeo.com/external/513292963.hd.mp4?s=15e2b175f65d45aa326e827a729bf6a3ce953adc&profile_id=175"
        type="video/mp4"
        crossorigin="anonymous"
      />
    </video>
  </collapsible-widget>
</template>

<script>
import CollapsibleWidget from "ireal-vue/widgets/CollapsibleWidget.vue";
import videojs from "video.js";
import Bus from "../services/bus.js";
import dataComponentMixin from "ireal-vue/mixins/data-component-mixin.js";

//import * as THREE from "videojs-vr/node_modules/three/build/three.js"

export default {
  mixins: [dataComponentMixin],
  components: { CollapsibleWidget },
  data() {
    return {
      source: "",
      playerTest: null
    };
  },
  async created(){
    import("videojs-vr/dist/videojs-vr.min.js");
  },
  mounted() {
    var player = (window.player = videojs("videojs-vr-player"));
    player.mediainfo = player.mediainfo || {};
    player.mediainfo.projection = "360"; //'360_LR': Used for side-by-side 360 videos
    player.poster(
      "https://media.routard.com/image/51/5/avion-en-vol.1567515.w740.jpg"
    );

    // AUTO is the default and looks at mediainfo
    // omnitone is for audio
    window.vr = player.vr({
      debug: false,
      omnitone: false,
      forceCardboard: false,
      omnitoneOptions: {},
      projection: "360"
    });

    // catch the program "ireal-start" ( send by the mutation store )
    Bus.$on("ireal-start", async () => {
      this.source = await this.getObservationVideo();
      this.$store.commit("test", this.source.parameters);
      if (this.source == undefined) {
        alert("no experience matches your criteria. Check your settings");
        this.$store.commit("stopPlayer");
      }

      this.datatime = {
        duration: this.source.duration,
        start: this.source.start,
        end: this.source.start + this.source.duration
      };
      if (this.source === undefined) {
        console.log("Erreur lors de la récupération du flux video");
        return;
      }
      // Configure player source
      player.src({
        type: "video/mp4",
        src: this.source.video_path_sd
      });

      // Compute time when the video must pause
      // this.source.duration === -1 for failure video
      this.pausetime =
        this.source.duration !== -1
          ? this.datatime.duration + this.datatime.start
          : player.duration();

      // Play video
      player.play();
      player.vr().camera.position.x = 3;
      console.log(player.vr());
      // Position video cursor
      // WARNING: condition 'loadedmetadata' is very important because otherwise the start time is not respected on safari
      // without 'loadedmetadata': the video launches since the beginning of the rush, on safari
      player.on("loadedmetadata", () => {
        player.currentTime(this.datatime.start);
        // TODO: trouver une meilleure astuce de positionnement du current time pour IOS
        // ici, on attends un moment pour faire un forward car avec cette action, le current time est bien pris en compte ...
        if (navigator.platform.includes("iPhone")) {
          setTimeout(() => {
            this.$store.commit("forwardPlayer", 1000);
          }, 100);
        }
      });

      // Set experiment duration based on video duration
      this.$store.commit("setDuration", this.datatime.duration * 1000);
      console.log(" video is loaded");
    });
  },
  methods: {
    prepare() {}
  }
};
</script>
